import { EXAMS } from "utils/constants";
import { createExporter } from "utils/createExporter";

export const ExamsExporter = createExporter(`${EXAMS}.xlsx`,
    [
        { key: "nameBg", label: "име на български език" },
        { key: "nameEn", label: "име на английски език" },
        { key: "description", label: "описание" },
    ],
    (record) => ({
        ...record,
        isActive: record.isActive ? "Да" : "Не"
    }),
);